export default "__VITE_ASSET__D4$yCRZ6__"